import React from 'react';

import ApprovedTag from 'components/Tags/ApprovedTag';
import ExpirationTag from 'components/Tags/ExpirationTag';
import RejectedTag from 'components/Tags/RejectedTag';

import { TagCol } from './styles';

interface TagPricesProps {
  time: { hours: number; minutes: number };
  status: string;
}

const TagPricesDetail = ({ status, time }: TagPricesProps) => (
  <TagCol>
    {status === 'Approved' || status === 'Confirmed' ? <ApprovedTag /> : <></>}
    {status === 'Reproved' ? <RejectedTag /> : <></>}
    {(status === 'None' || status === 'PreApproved' || status === 'Pending') && <ExpirationTag showIcon time={time} />}
  </TagCol>
);

export default TagPricesDetail;
